module.exports = __webpack_public_path__ + "static/media/residencial.42cff403.jpg";